import { connect as reduxConnect } from 'react-redux';

export function connect(Component, selectProps, selectActions) {
    return reduxConnect(selectProps, selectActions)(Component);
}

